
import { route } from 'quasar/wrappers'
import { createRouter, createMemoryHistory, createWebHistory, createWebHashHistory } from 'vue-router'

/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Router instance.
 */

let routes = [{
	name: 'main',
	path: '/',
	component: () => import('layouts/MainLayout.vue'),
	children: [
		
		{ path: '/home',name: 'home', component: () => import('pages/home/home.vue'), props: true },//Dashboard routes


//agendamento routes

//anamnese routes

//atend_cac routes
		{ path: '/atend_cac', name: 'atend_caclist', component: () => import('pages/atend_cac/list.vue'), props: true },
		{ path: '/atend_cac/index/:fieldName?/:fieldValue?', component: () => import('pages/atend_cac/list.vue'), props: true },
		{ path: '/atend_cac/view/:id', name: 'atend_cacview', component: () => import('pages/atend_cac/view.vue'), props: true },
		{ path: '/atend_cac/add', name: 'atend_cacadd', component: () => import('pages/atend_cac/add.vue'), props: true },
		{ path: '/atend_cac/edit/:id', name: 'atend_cacedit', component: () => import('pages/atend_cac/edit.vue'), props: true },
		{ path: '/atend_cac/chamadas', name: 'atend_cacchamadas', component: () => import('pages/atend_cac/chamadas.vue'), props: true },

//atendimento routes

//atendimento_tipo routes

//audits routes

//avaliacoes routes

//beneficios routes

//carac_familiar routes

//caracteristicas routes

//casos routes

//cnae routes

//contatos routes

//diagnosticos routes

//encaminhamento routes

//especialidades routes

//fornecedores routes

//manutencao routes

//motivos routes

//municipes routes
		{ path: '/municipes', name: 'municipeslist', component: () => import('pages/municipes/list.vue'), props: true },
		{ path: '/municipes/index/:fieldName?/:fieldValue?', component: () => import('pages/municipes/list.vue'), props: true },
		{ path: '/municipes/view/:id', name: 'municipesview', component: () => import('pages/municipes/view.vue'), props: true },
		{ path: '/municipes/add', name: 'municipesadd', component: () => import('pages/municipes/add.vue'), props: true },
		{ path: '/municipes/edit/:id', name: 'municipesedit', component: () => import('pages/municipes/edit.vue'), props: true },

//oficios routes

//orgao_permissao routes

//orgaos routes

//profissoes routes

//satisfacao routes

//servicos_veiculos routes

//solicitacoes routes

//status_agendamento routes

//tipo_beneficio routes

//users routes

//usuarios routes
		{ path: '/usuarios', name: 'usuarioslist', component: () => import('pages/usuarios/list.vue'), props: true },
		{ path: '/usuarios/index/:fieldName?/:fieldValue?', component: () => import('pages/usuarios/list.vue'), props: true },
		{ path: '/usuarios/view/:id', name: 'usuariosview', component: () => import('pages/usuarios/view.vue'), props: true },
		{ path: '/usuarios/add', name: 'usuariosadd', component: () => import('pages/usuarios/add.vue'), props: true },
		{ path: '/usuarios/edit/:id', name: 'usuariosedit', component: () => import('pages/usuarios/edit.vue'), props: true },

//veiculos routes

		
		
		
		

		//Error pages
		{ path:  '/error/forbidden', name: 'forbidden',  component: () => import('pages/errors/forbidden.vue') },
		{ path: '/error/notfound',  name: 'notfound', component: () => import('pages/errors/pagenotfound.vue') }
	],
	
	},
	{ path: '/:catchAll(.*)*', component: () => import('pages/errors/pagenotfound.vue') }
];

export default route(async function () {
  const createHistory = process.env.SERVER
    ? createMemoryHistory
    : (process.env.VUE_ROUTER_MODE == 'history' ? createWebHistory : createWebHashHistory)
	
	let mainRoute = routes.find(x => x.name = "main");
	

	

	const Router = createRouter({
    scrollBehavior: () => ({ left: 0, top: 0 }),
    routes,
    // Leave this as is and make changes in quasar.conf.js instead!
    // quasar.conf.js -> build -> vueRouterMode
    // quasar.conf.js -> build -> publicPath
    history: createHistory(process.env.VUE_ROUTER_BASE)
  })
  return Router
})

